import React from 'react';
import './CartTitle.css';

function CartTitle({message, quantity}) {
    const getQuantity = () => {
        if (quantity < 10) return `0${quantity}`;
        else return quantity;
    };

    return (
        <div className='cart-title'>
            <div className='cart-title_label'>{message || 'Carro de compras'}</div>
            <div className='cart-title_quantity'>{getQuantity()}</div>
        </div>
    );
}

export default CartTitle;